export function aliasToShortUid(alias: string): string {
  // alias format: cs_personalize_[alias_id]_[active_variant] - cs_personalize_0_1
  return alias.split('_')[2];
}
